export enum CrudOperator {
  EQUAL = '$eq',
  NOT_EQUAL = '$ne',
  GREATER = '$gt',
  LOWER = '$lt',
  GREATER_EQUAL = '$gte',
  LOWER_EQUAL = '$lte',
  OR = '$or',
  AND = '$and',
  STARTS = '$starts',
  CONTL = '$contL',
  IS_NULL = '$isnull',
  NOT_NULL = '$notnull',
  IN = '$in'
}
